// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N9U_C{display:flex;flex-direction:column;width:100%;margin-block:24px}.vfIwQ{display:flex;flex-direction:column;gap:24px}.UpXdr .vfIwQ{gap:8px}.AxMYc{touch-action:pan-y !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `N9U_C`,
	"cardList": `vfIwQ`,
	"mobile": `UpXdr`,
	"draggableGridItem": `AxMYc`
};
export default ___CSS_LOADER_EXPORT___;
